export const FETCH_RESULT = 'FETCH_RESULT';
export const LIST_RESULT = 'LIST_RESULT';
export const DRAW_RESULT = 'DRAW_RESULT';

